import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ReceiptIcon from '@material-ui/icons/Receipt';
// Components
import PurchaseOrderApprovalTable from "./PurchaseOrderApprovalTable";

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import {get_cookies} from "../../components/Cookies/Cookies";

//Modal
import LoadingModal from "../../components/Modal/LoadingModal";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const PurchaseApprovalView = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(false);

	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);

	let history = useHistory();

	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.itemid);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.itemid){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.itemid, 
				qty: item.qty,
				price: item.cost, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
			
	}, []);

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty))
		setPoTotal(po_total);
		setPoTotal()
	}, [items]);


	const data = async () => {
		 await axios.get(process.env.REACT_APP_API_URL+'get_single_po_for_approval', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		}).then((res=>{
			setSupplierInfo(res.data.data[0].customer_info);
			setItems(res.data.data[1].item_info);
			setShipTotal(res.data.data[2].other_info.freight)
			setPoTotal(res.data.data[2].other_info.sub_total);
			setGrandTotal(res.data.data[2].other_info.grand_total);
			setNotes(res.data.data[2].other_info.notes);
		})).catch((error=>{
			// console.log(error.message);
		}));
	};	

	const approve_po = async () => {
		setBtnDisabled(true); 
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("pono", pono);
		formData.append("jc_uname",  get_cookies('username'));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("curcode", get_cookies('curcode'));
		await axios.post(process.env.REACT_APP_API_URL+'approve_po', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}

			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsgType("success");
				setMsg("PO Approved");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					// history.push('/purchases/purchases-order-approval-history');
					history.push('/purchases/purchases-order-approval-history-view/'+res.data.pono+'/'+res.data.brandchidno);
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal  
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-approval"}><h2 style={{color:"black"}}>Purchase Order Approval</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order #{pono}</h2>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			</div>
			{supplierInfo?(<div className="page-container">
				<Card className={classes.card} style={{marginTop:"1.5em"}}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Approval Information
								</div>
								<div className={classes.title}>
									{supplierInfo.deliver_to || "Deliver To"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<LoadingModal showModal={showModal}/>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.date_of_delivery || "Date of delivery"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Deliver To: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.deliver_to || "Deliver To"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.contact_no || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderApprovalTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal).format('0,0.00')}	
									</div>							
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(poTotal).format('0,0.00')}	
									</div>
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(grandTotal).format('0,0.00')}	
									</div>
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
				{get_cookies('can_approve') == 1 ?
					<Button style={{backgroundColor: "#4caf50", color:"#fff"}} disabled={btnDisabled} variant="contained" color="primary" onClick={approve_po}>
						Approve
					</Button>
					:null}
				</div>
			</div>):(<Preloader />)}
		
		</div>
	);
};

export default PurchaseApprovalView;
